import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper, IconButton} from 'material-ui';
import Loading from "../../../common/Loading/Loading";
import Error from "../../../common/Error/Error";
import MediaType from '../MediaType/MediaType';
import style from "../../../../styles/styles";
import {deleteMediaType, getMediaTypes} from "../../../../store/mediatypes/actions";
import {connect} from "react-redux";
import {FlatButton, Dialog} from "material-ui";
import ContentAdd from 'material-ui/svg-icons/content/add';
import {white} from "material-ui/styles/colors";
import {Link} from "react-router-dom";
import withTranslation from "../../../../hoc/withTranslation";
import {ADD_MEDIA_TYPE_PAGE} from "../../../../constants/routes";

export class SmartMediaTypeList extends React.Component {

    static propTypes = {
        title: PropTypes.string
    };

    state = {
        mediaTypeToRemove: null,
        openRemoveMediaType: false
    };

    componentWillMount() {
        this.props.getMediaTypes(this.props.app.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            if (this.state.mediaTypeToRemove) { // admin has been added
                this.handleCloseMediaType()
            }
        }
    }

    // Delete mediaType

    handleDeleteMediaType = (mediaType) => {
        this.setState({
            openRemoveMediaType: true,
            mediaTypeToRemove: mediaType
        });
    };

    handleCloseMediaType = () => {
        this.setState({
            openRemoveMediaType: false,
            mediaTypeToRemove: null
        });
    };

    deleteMediaType = () => {
        this.props.deleteMediaType(this.props.app.id, this.state.mediaTypeToRemove.id);
    };

    // Render

    renderDeleteMediaTypeDialog(mediaType) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseMediaType}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteMediaType}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveMediaType}
                    onRequestClose={this.handleCloseMediaType}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html:
                            this.props.t('settings_page.remove_media_type_confirmation', {name: mediaType.name})
                    }}/>
                </p>
                }
            </Dialog>
        );
    }

    render() {
        const {loading, mediaTypes, title, user, app} = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false}/>;
        } else if (mediaTypes.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('settings_page.add_some_media_types')}
                />
        } else {
            content = mediaTypes.map((mediaType, index) => {
                return (
                    <div key={mediaType.id}>
                        <MediaType
                            app={app}
                            mediaType={mediaType}
                            user={user}
                            handleRemoveMediaType={this.handleDeleteMediaType}
                        />
                        {index !== (mediaTypes.length - 1) && <Divider inset={true}/>}
                    </div>
                )
            })
        }

        return (
            <div>
                {this.state.mediaTypeToRemove && this.renderDeleteMediaTypeDialog(this.state.mediaTypeToRemove)}
                <Paper>
                    <List>
                        <Subheader style={{...style.subHeader, ...style.relative}}>
                            {title}
                            <Link to={ADD_MEDIA_TYPE_PAGE.replace(':appId', this.props.app.id)}>
                                <IconButton
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_type')}
                                    tooltipPosition='top-center'
                                >
                                    <ContentAdd color={white}/>
                                </IconButton>
                            </Link>
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        app: state.apps.currentApplication,
        user: state.auth.content,
        loading: state.mediaTypes.pending,
        sending: state.mediaTypes.sending,
        mediaTypes: state.mediaTypes.content
    };
}

export default connect(mapStateToProps, {
    deleteMediaType,
    getMediaTypes
})(withTranslation(SmartMediaTypeList));



// WEBPACK FOOTER //
// src/components/media/MediaType/SmartMediaTypeList/SmartMediaTypeList.js